import { css } from 'styled-components';

const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};

// iterate through the sizes and create a media template
/* eslint-disable */
export const media = Object.keys(breakpoints).reduce((accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = breakpoints[label] / 16;
    accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)}
    }
  `;
    return accumulator
}, {});

export const clearfix = () => {

    return css`
        &:before,
        &:after {
            content: " ";
            display: table;
        }
        &:after {
            clear: both;
        }
    `;

};

const maximumColumns = 12;

export const row = (padding = 15) => {

    return css`
        box-sizing: border-box;
        margin-left: ${Math.ceil(-padding)}px;
        margin-right: ${Math.floor(-padding)}px;
        ${clearfix()}
    `;

};

export const column = (columns, size, padding = 15, float = 'left') => {

    return css`
        box-sizing: border-box;
        position: relative;
        min-height: 1px;
        padding-left: ${padding}px;
        padding-right: ${padding}px;
        
        ${media[size]`
            float: ${float};
            width: ${100 * (columns / maximumColumns)}%;
        `}
    `;

};

const containerMaxWidths = {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140
};

export const container = (padding = 0) => {

    return css`
        box-sizing: border-box;
        margin-right: auto;
        margin-left: auto;
        padding-left: ${Math.floor(padding)}px;
        padding-right: ${Math.ceil(padding)}px;
        
        ${clearfix()}
        
        ${media['sm']`
            max-width: ${containerMaxWidths['sm']}px;
        `}
        
        ${media['md']`
            max-width: ${containerMaxWidths['md']}px;
        `}
        
        ${media['lg']`
            max-width: ${containerMaxWidths['lg']}px;
        `}
        
        ${media['xl']`
            max-width: ${containerMaxWidths['xl']}px;
        `}

    `;

};

export const mediaFontSizes = (sm, md, lg) => {

    return css`
        font-size: ${sm};
  
        ${media.md`
            font-size: ${md};
        `}
  
        ${media.lg`
            font-size: ${lg};
        `}
    `
};


// WEBPACK FOOTER //
// ./src/globals.js